/* istanbul ignore file */
import React from 'react';
import { Link } from 'react-router-dom';
import { Link as MuiLink } from '@mui/material';
import { useCandidateUrl } from './route/hooks/useCandidateUrl';

const CandidateLink = ({
  style,
  color,
  name,
  id,
  onClick,
}: {
  name?: string;
  id: number | string;
  style?: Dictionary<string>;
  color?: string;
  onClick?: (event: React.MouseEvent<HTMLAnchorElement>) => void;
}) => {
  const { getSingleEntityUrl } = useCandidateUrl();

  return (
    <>
      {onClick ? (
        <MuiLink
          style={style}
          onClick={onClick}
          role="button"
          color={color || 'primary'}
          sx={{ cursor: 'pointer', textDecoration: 'none' }}
        >
          {name || id}
        </MuiLink>
      ) : (
        <Link style={style} color={color} to={getSingleEntityUrl(id)} onClick={onClick}>
          {name || id}
        </Link>
      )}
    </>
  );
};

export default CandidateLink;
